/**
 * check whether the schema belongs to section type
 * @param uiSchema ui json schema
 */
export function getHasChild(uiSchema: UISchema) {
  return !!uiSchema["ui:order"]?.length;
}
